export default __webpack_public_path__ + "static/media/Automated-Data-Flow.99b9f7ce.svg";